/*jshint -W069 */
/**
 *
 * @class Api
 * @param {(string|object)} [domainOrOptions] - The project domain or options object. If object, see the object's optional properties.
 * @param {string} [domainOrOptions.domain] - The project domain
 * @param {object} [domainOrOptions.token] - auth token - object with value property and optional headerOrQueryName and isQuery properties
 */
var Api = (function() {
  'use strict';

  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : settingsInstance.baseApiNewUrl;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  /**
   * Usuń klauzule
   * @method
   * @name Api#deleteKlauzule
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteKlauzule = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz klauzule
   * @method
   * @name Api#getKlauzule
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getKlauzule = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined) {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (parameters['filter_str'] !== undefined) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Dodaj klauzule
   * @method
   * @name Api#postKlauzule
   * @param {object} parameters - method options and parameters
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.postKlauzule = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Usuń klauzule
   * @method
   * @name Api#deleteKlauzuleById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID
   * @param {string} parameters.token - Token
   */
  Api.prototype.deleteKlauzuleById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'DELETE',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz klauzule
   * @method
   * @name Api#getKlauzuleById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.id - ID
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getKlauzuleById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Edytuj klauzule
   * @method
   * @name Api#putKlauzuleById
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID klauzuli
   * @param {} parameters.body -
   * @param {string} parameters.token - Token
   */
  Api.prototype.putKlauzuleById = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule/{id}',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    parameterPath = parameterPath.replace('{id}', parameters['id']);

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['body'] !== undefined) {
      body = parameters['body'];
    }

    if (parameters['body'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: body'));
      return deferred.promise;
    }

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'PUT',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  /**
   * Pobierz klauzule
   * @method
   * @name Api#getKlauzuleRaport
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.token - Token
   * @param {string} parameters.page_number - Numer strony (domyślnie None - zwracana całość)
   * @param {string} parameters.items_per_page - Ilość elementów na stronę (domyślnie None - zwracana całość)
   * @param {string} parameters.order_by - Wg której kolumny sortowanie (domyślnie id)
   * @param {boolean} parameters.desc - Czy sortowanie zstępne
   * @param {string} parameters.filter_str - Treść filtra
   * @param {string} parameters.control - Parametr kontrolny
   */
  Api.prototype.getKlauzuleRaport = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }
    var deferred = Q.defer();
    var domain = this.domain,
      path = '/klauzule_raport',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];

    if (parameters['wso2_id'] !== undefined) {
      headers['wso2_id'] = parameters['wso2_id'];
    }

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    if (parameters['page_number'] !== undefined) {
      queryParameters['page_number'] = parameters['page_number'];
    }

    if (parameters['items_per_page'] !== undefined) {
      queryParameters['items_per_page'] = parameters['items_per_page'];
    }

    if (parameters['order_by'] !== undefined) {
      queryParameters['order_by'] = parameters['order_by'];
    }

    if (parameters['desc'] !== undefined) {
      queryParameters['desc'] = parameters['desc'];
    }

    if (
      parameters['filter_str'] !== undefined &&
      parameters['filter_str'].replace(/\s/g, '').length > 0 &&
      parameters['filter_str'].length > 0
    ) {
      queryParameters['filter_str'] = parameters['filter_str'];
    }

    if (parameters['control'] !== undefined) {
      queryParameters['control'] = parameters['control'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };
  return Api;
})();

exports.Api = Api;
